/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 2890
// module chunks = 0 2